import { useEffect, useState } from "react";
import { paymentsService } from "../../services/paymentsService";
import { Payment } from "../../utils/database";
import useToken from "../../../../hooks/auth/useToken";

interface Props {
  limit?: number;
}

export default function usePayments({ limit }: Props) {
  const [payments, setPayments] = useState<Payment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();
  /**
   * Récupération des payments avec filtres (provenant des props)
   */
  const getPayments = async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const paymentsData = await paymentsService.getPayments(token, { limit: limit });
      const list = paymentsData?.payments || [];
      setPayments(list);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setError(error);
      setLoading(false);
    }
  };

  const deletePayment = async (paymentId: string) => {
    try {
      getPayments();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  const updatePayment = async (updatePayment: Payment) => {
    if (!updatePayment.id) {
      alert("Une erreur s'est produite lors de la mise à jour du paiement");
      return;
    }
    try {
      getPayments();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  /**
   * Recharger les payments quand les filtres changent
   */
  useEffect(() => {
    getPayments();
  }, [token]); // dépendance sur les filtres

  return {
    payments,
    getPayments,
    length: payments.length,
    paymentsLoading: loading,
    paymentsError: error,
    deletePayment,
    updatePayment,
  };
}
